import { validateCpf } from '@/helpers'
import { z } from 'zod'

export const dependentFormSchema = z.object({
  name: z.string().min(1, 'Obrigatório'),
  tax_id: z.string().min(1, 'Obrigatório').refine(validateCpf, 'CPF inválido'),
  birthdate: z.date().nullish(),
  type: z.string().min(1, 'Obrigatório'),
  irrf_deduction: z.union([
    z.boolean(),
    z.string().refine((val) => val !== '', 'Obrigatório'),
  ]),
})

export type DependentFormData = z.infer<typeof dependentFormSchema>
